import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ApiResponse } from '@core/models/api-response.model';
import { Pagination } from '@core/models/pagination.model';
import { PaymentGatewayBot } from '@core/models/payment-gateway-bot.model';
import { SKIP_ERROR_INTERCEPTOR_HEADER } from '@utils/constants';

@Injectable()
export class PaymentGatewayBotDataService extends DefaultDataService<PaymentGatewayBot> {

  pagination: Pagination;
  messages$ = new Subject<any[]>();

  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
    super('PaymentGatewayBot', http, httpUrlGenerator, { root: '' });
  }

  getAll(): Observable<PaymentGatewayBot[]> {
    return this.http.get<ApiResponse>('/banksys/paymentgatewaybot').pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  getWithQuery(pageParam: string): Observable<PaymentGatewayBot[]>{
    return this.http.get<ApiResponse>(`/banksys/paymentgatewaybot${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data?.rows ?? res.data)
    );
  }

  updateSwitch(id: number, param: any) {
    return this.http.put<ApiResponse>(`/banksys/paymentgatewaybot/${id}`, param).pipe(
      tap(res =>  this.messages$.next(res.message))
    );
  } 
  
  updateTAC(data: any) {
    return this.http.post<ApiResponse>(`/banksys/paymentgatewaybot/updatetac`, data).pipe(
      tap(res =>  this.messages$.next(res.message))
    );
  }

  getTAC(data: any) {

    const headers = {
        [SKIP_ERROR_INTERCEPTOR_HEADER]: 'true'
      };

    return this.http.post<ApiResponse>(`/banksys/paymentgatewaybot/gettac`, data, { headers }).pipe(
      map(res => res.data)
    );
  }

  createReconJob(data: any) {
    return this.http.post<ApiResponse>(`/banksys/createpgreconjob`, data).pipe(
      tap(res =>  this.messages$.next(res.message))
    );
  }

  private paginationInit(res: any) {
    if(res) {
      this.pagination = res.data.paginations;
    }
  }

}
